'use strict';

var _collection = require('common/models/base/collection');

var _collection2 = _interopRequireDefault(_collection);

var _signature = require('./signature');

var _signature2 = _interopRequireDefault(_signature);

var _sift = require('sift');

var _sift2 = _interopRequireDefault(_sift);

var _extend = require('lodash/object/extend');

var _extend2 = _interopRequireDefault(_extend);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var Signatures = _collection2['default'].extend({

    apiEndpointAlias: 'signatures',

    mixins: [require('common/models/mixins/collection')],

    createModel: function createModel(properties) {
        return _signature2['default'].create((0, _extend2['default'])({
            'notifier': this.notifier
        }, properties));
    },

    add: function add(properties) {
        var _this = this;

        var self = this;
        var signature = this.createModel({
            'data': properties
        });

        return signature.insert().then(function (resp) {
            if (resp.error) {
                return Promise.reject(resp);
            }
            _this.unshift(signature);
            return Promise.resolve(signature);
        });
    },

    addFromEdit: function addFromEdit(signature) {
        var _this2 = this;

        return signature.edit().then(function () {
            _this2.unshift(signature);
            return Promise.resolve(signature);
        });
    },

    find: function find(guid) {
        for (var i = 0; i < this.length; i++) {
            var sig = this[i];
            if (sig && sig.guid === guid) {
                return sig;
            }
        }
    },

    //  ----  DATA  ---------------------------------------

    onDataChange: function onDataChange(data) {

        var signatures = [];
        if (data && data.count) {
            for (var i = 0; i < data.count; i++) {
                signatures.push(this.createModel({ 'data': data.list[i] }));
            }
        }

        // this.mergeSourceData(signatures); // TODO - more optimial
        this.splice.apply(this, [0, this.length].concat(signatures));
    }

});

module.exports = Signatures;


/*****************
 ** WEBPACK FOOTER
 ** ./src/hellosign/models/signatures.js
 ** module id = 394
 ** module chunks = 0
 **/